import {MenuStrategy} from "../MenuStrategy";

export class DispositiviMenuStrategy extends MenuStrategy {
   constructor() {
    super('Dispositivi', '', '');
  }
}